import { useEffect, useContext } from "react";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { IRolesTableReport } from "../../../Interfaces/roleAndPermissionsInterfaces";
import { RolesTableContext } from "./Table";
import { RolesTableAdditional } from "./Additional";
import { CommonTableUI } from "../../TableTemplate/common";

const TableUI: React.FC<ITableUI<IRolesTableReport>> = ({
  reports,
  onAction,
}: ITableUI<IRolesTableReport>) => {
  const { refreshTableFlag, setRefreshTableFlag } =
    useContext(RolesTableContext);

  useEffect(() => {
    if (refreshTableFlag && onAction) {
      setRefreshTableFlag(false);
      onAction();
    }
  }, [refreshTableFlag]);

  return (
    <CommonTableUI
      reports={reports}
      onAction={onAction}
      AdditionalBody={RolesTableAdditional}
      tableBoxClassName="max-h-[calc(100dvh-230px)] overflow-y-auto"
    />
  );
};

export default TableUI;
